import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IProfileRepository } from '../../repositories/interfaces/iProfileRepository';

export interface IAccountRetrievalGenerateOTPUseCase {
    execute(apiKey: string, identityToken: string, token: string, username: string): Promise<any>;
}

export class AccountRetrievalGenerateOTPUseCase implements IAccountRetrievalGenerateOTPUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get profileRepository(): IProfileRepository {
        return container.resolve<IProfileRepository>(DI.REPOSITORIES.IProfileRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(apiKey: string, identityToken: string, token: string, username: string): Promise<any> {
        const result = await this.profileRepository.accountRetrievalGenerateOTP(apiKey, identityToken, token, username);
        return result.data;
    }
}
